<template>
  <a-modal :title="viewTitle" visible @cancel="cancel">
    <ak-model-table model="activityRecord" :filters="filters" />
    <template slot="footer">
      <a-button type="primary" @click="cancel">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'viewPage',
  data () {
    return {
      filters: {
        activity: this.record.objectId
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('complete', 'cancel')
    }
  },
  props: {
    record: Object, // 当前行的数据
    model: Object, // 当前model对象
    field: Object, // 当前field对象
    viewTitle: {
      type: String,
      default: '参与用户'
    }
  }
}
</script>

<style scoped>
</style>
